// extracted by mini-css-extract-plugin
export default {"container":"FileUpload_container__tckJT","actions":"FileUpload_actions__NArj8","maxSize":"FileUpload_maxSize__GL7RA","button":"FileUpload_button__wZ-Hj"};